import { withStyles } from "@material-ui/core";
import React from "react";
import DataGrid from '@dataGrid';
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from "../../../components/GridHeader";
import GridConfig from "./gridConfig";

const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .ag-theme-material .ag-icon-checkbox-checked": {
      color: theme.HeaderSelectedText,
    },
    "& .ag-theme-material .checkBoxHeader": {
      display: "flex",
      paddingLeft: 24,
    },
    [`& .gridTheme-${theme.themeName}`]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  gridContent: {
    borderColor: theme.AppBGColor,
    borderStyle: "solid",
    borderWidth: "1px",
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
});
class TrapTrailersGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
    this.gridConfig = new GridConfig();
  }

  componentDidMount() {
    this.props.glEventHub.on("trapTrailersGrid", this.onSearchTextChanged);
  }

  componentWillUnmount() {
    this.props.glEventHub.off("trapTrailersGrid", this.onSearchTextChanged);
  }

  onSearchTextChanged = (searchText) => {
    this.setState({
      searchText,
    });
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + " Trap Trailers",
        filterCondition: "",
      },
    ];
  };

  render() {
    const { config } = this.gridConfig;
    const { classes, ...rest } = this.props;
    return (
      <div className={`${classes.dataGrid} ${classes.gridContent}`}>
        <GridHeader
          title="Trap Trailers"
          headerId="trapTrailersGrid"
          glEventHub={this.props.glEventHub}
          gridApi={this.props.gridApi}
        />
        <DataGrid
          defaultColDef={config.defaultColDef}
          columnDefs={config.columns}
          config={config}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          deltaRowDataMode={true}
          getRowId={(params) => params.data.id}
          quickFilterText={this.state.searchText}
          suppressRowClickSelection
          panelLabel={(filteredData) => (
            <StatusBar data={this.constructStatusBar(filteredData)} />
          )}
          rowClassRules={config.rowClassRules}
          {...rest}
        />
      </div>
    );
  }
}

export default withStyles(styles)(TrapTrailersGrid);
